import { DISCORD_URL } from "@kitsulab/schema";
import { ArrowRight, MessageCircle, PartyPopper, Sparkles, Ticket } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";

export function HostedDemoCompletion({ busy, onExplore, onCreate }: {
	busy: boolean;
	onExplore: () => void;
	onCreate: () => void;
}) {
	const { t } = useTranslation();
	return <section data-demo-completion className="mt-4">
		<div className="rounded-xl border border-violet-400/30 bg-gradient-to-br from-violet-500/20 via-fuchsia-500/10 to-transparent p-5">
			<div className="mb-4 flex items-center gap-3 text-violet-200" aria-hidden="true">
				<PartyPopper size={30} /><Sparkles size={20} className="text-amber-200" />
			</div>
			<h3 className="text-xl font-bold text-white">{t("hostedDemo.completion.title")}</h3>
			<p className="mt-2 text-sm leading-relaxed text-violet-100">{t("hostedDemo.completion.description")}</p>
		</div>
		<p className="mt-4 text-sm leading-relaxed text-zinc-200">{t("hostedDemo.completion.experiments")}</p>
		<p className="mt-2 text-xs leading-relaxed text-zinc-400">{t("hostedDemo.completion.refresh")}</p>
		<button disabled={busy} onClick={onExplore}
			className="mt-5 flex w-full items-center justify-center gap-2 rounded-xl bg-gradient-to-r from-violet-600 to-indigo-500 px-4 py-3 text-sm font-semibold text-white disabled:opacity-50">
			{t("hostedDemo.completion.explore")}<ArrowRight size={16} aria-hidden="true" />
		</button>
		<button disabled={busy} onClick={onCreate} className="mt-3 w-full text-sm text-violet-200 disabled:opacity-50">
			{t("hostedDemo.studioSetup")}
		</button>
		<div className="mt-5 border-t border-white/10 pt-4">
			<p className="text-sm text-zinc-300">{t("hostedDemo.completion.help")}</p>
			<div className="mt-3 flex flex-wrap gap-3 text-sm font-medium text-violet-200">
				<Link to="/support" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 rounded-lg border border-violet-400/25 px-3 py-2 hover:bg-violet-400/10">
					<Ticket size={16} aria-hidden="true" />{t("hostedDemo.completion.ticket")}
				</Link>
				<a href={DISCORD_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 rounded-lg border border-violet-400/25 px-3 py-2 hover:bg-violet-400/10">
					<MessageCircle size={16} aria-hidden="true" />{t("hostedDemo.completion.discord")}
				</a>
			</div>
		</div>
	</section>;
}
